import React, { Component } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';

import Table from '../components/table/table';
import TableRegisterButton from '../components/table/registerButton';
import ModalComponent from '../components/modal';

import ManufacturersAction from '../app/store/actions/manufacturers';

import Notification from '../components/notifications';
import itemsPage from '../data/itemsPage';

import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';

class ManufacturersPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: itemsPage.page.limit,
      show: false,
      page: 1,
      search: '',
      showModal: false,
      orderBy: 'ASC',
      field: 'id',
    };
  }

  componentDidMount() {
    this.searchManufacturers();
  }

  updateValues = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.searchManufacturers();
  }

  searchManufacturers = async () => {
    const {
      search, page, limit, orderBy, field = '',
    } = this.state;
    const skip = (page - 1) * limit;

    await this.props.getManufacturers(limit, skip, search, orderBy, field);
  }

  deleteManufacturerModal = async (manufacturerId) => {
    await this.setState({ selectItemToDelete: manufacturerId, showModal: true });
  }

  deleteManufacturer = async () => {
    const { selectItemToDelete } = this.state;

    if (selectItemToDelete) {
      await this.props.deleteManufacturer(selectItemToDelete);
      await this.setState({ selectItemToDelete: undefined, showModal: false });
      await this.searchManufacturers();
      this.deleteNotification();
    }
  }

  deleteNotification = () => {
    this.setState({ show: true });
    setTimeout(() => { this.setState({ show: false }); }, 5000);
  }

  active = async (active, id) => {
    await this.props.updateManufacturer({ active, id });
    await this.searchManufacturers();
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.searchManufacturers();
  }

  render() {
    const {
      limit, show, page, showModal,
    } = this.state;
    const { manufacturers = {} } = this.props;

    const tableHeader = [
      { key: 'id', value: 'ID' },
      { key: 'name', value: I18n.t('name') },
      /* { key: 'redirectUrl', value: I18n.t('redirectUrl') }, */
      { key: 'description', value: I18n.t('description') },
      { key: 'active', value: I18n.t('active') },
      { key: 'action', value: I18n.t('action') },
    ];

    const tableData = (manufacturers.rows || []).map((row, index) => ({
      key: index,
      id: row.id,
      name: row.name,
      /* redirectUrl: row.redirectUrl, */
      description: row.description,
      active: (
        <div className="row margin-left-0">
          <button
            type="button"
            className={`btn btn-${row.active ? 'warning' : 'dark'} promotion-btn-${row.active ? 'warning' : 'active'}`}
            onClick={() => this.active(!row.active, row.id)}
          >
            <Translate value={row.active ? 'disable' : 'active'} />
          </button>
        </div>
      ),
      action: (
        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
          <div className="btn-group" role="group">
            <button
              id="btnGroupDrop1"
              type="button"
              className="btn btn-secondary dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <Translate value="action" />
            </button>
            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
              <button
                type="button"
                className="dropdown-item dropdown-table"
                onClick={() => history.push({
                  pathname: ROUTES.MANUFACTURERS_FORM,
                  search: `?id=${row.id}`,
                })}
              >
                <Translate value="edit" />
              </button>
              <button
                type="button"
                className="dropdown-item dropdown-table"
                onClick={() => this.deleteManufacturerModal(row.id)}
              >
                <Translate value="delete" />
              </button>
            </div>
          </div>
        </div>
      ),
    }));

    const tableButtons = (
      <React.Fragment>
        <TableRegisterButton route={{ pathname: ROUTES.MANUFACTURERS_FORM }} />
        {/* <button
          onClick={() => history.push(ROUTES.UPLOAD_MANUFACTURERS)}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="import" />
        </button>

        <button
          onClick={() => this.props.getCsvManufacturersReport()}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="export" />
        </button> */}
      </React.Fragment>
    );

    return (
      <div className="main-div-tables">

        <ModalComponent
          title={I18n.t('delete')}
          body="Deseja realmente excluir o fabricante?"
          visible={showModal}
          closeModal={() => this.setState({ showModal: false })}
          titleOkButtoon={I18n.t('confirm')}
          size={{ width: '300px', height: '170px' }}
          showButtons
          showCancel
          confirmModal={this.deleteManufacturer}
        />

        <Table
          title={I18n.t('manufacturers')}
          buttons={tableButtons}
          header={tableHeader}
          lines={tableData}
          page={page}
          perPage={limit}
          count={manufacturers.count}
          searchItems={this.updateValues}
          showItemsCount
          sortTable={this.sortTable}
        />

        {show && <Notification classe="success" message={I18n.t('productDeleted')} /> }
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getManufacturers: (limit, skip, search, order, field) => dispatch(
    ManufacturersAction.getManufacturers(limit, skip, search, order, field),
  ),
  updateManufacturer: manufacturer => dispatch(ManufacturersAction.updateManufacturer(manufacturer)),
  deleteManufacturer: id => dispatch(ManufacturersAction.deleteManufacturer(id)),
  getCsvManufacturersReport: () => dispatch(ManufacturersAction.getCsvManufacturersReport()),
});

const mapStateToProps = state => ({
  manufacturers: state.manufacturers && state.manufacturers.manufacturers,
});

export default connect(mapStateToProps, mapDispatchToProps)(ManufacturersPage);
